<template>
  <div class="relative w-full h-full">
    <img ref="image" :src="`plans/units/${rotate}/${name}.png`" class="w-auto max-h-full" data-action="zoom" :alt="name">
  </div>
  <!-- <div class="relative w-full h-full">
    <photo-swipe class="w-auto max-h-full gallery">
      <a :href="imagePath" :data-width="917" :data-height="1012" class="gallery-item">
        <img ref="image" :src="imagePath" class="w-auto max-h-full" :alt="name">
      </a>
    </photo-swipe>
  </div> -->
</template>

<script>
// import mediumZoom from 'medium-zoom'

export default {
  name: 'PropertyUnitImage',
  props: {
    name: {
      type: String,
      required: true,
    },
    rotate: {
      type: Number,
      required: false,
      default: 0,
      validator: (value) => [0, 90, 180, 270].indexOf(value) !== -1,
    },
  },
  data () {
    return {
      mediumZoom: undefined,
    }
  },
  computed: {
    imagePath () {
      return `plans/units/${this.rotate}/${this.name}.png`
    },
  },
  mounted () {
    // this.mediumZoom = mediumZoom(this.$refs.image, {
    //   margin: 64,
    // })
  },
  beforeUnmount () {
    // if (typeof this.mediumZoom === 'function') {
    //   this.mediumZoom.detach()
    // }
  },
}
</script>
